import React from "react";
import resourceNames from "../../../../common/data/resourceNames";
import { DriverLogEventEdit } from "./DriverLogEventEdit";
import { DriverLogDetailedView } from "../../../../common/data/service-proxies";
import { DriverLogViewChildRoute } from "./DriverLogViewChildRoute";
import { DriverLogAddRemark } from "./DriverLogAddRemark";
import { Switch } from "react-router-dom";
import { DriverLogAddStatus } from "./DriverLogAddStatus";
import { DriverLogExceptionAdd } from "./DriverLogExceptionAdd";
import { useActionPermissions } from "../../../../common/auth/useActionPermissions";
import permissionNames from "../../../../common/auth/access-control/permissionNames";

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  record: DriverLogDetailedView;
}

export const DriverLogViewChildRoutes = ({
  onClose,
  onSuccess,
  record,
}: Props) => {
  const permissions = useActionPermissions();
  return (
    <Switch>
      {permissions && permissions[permissionNames.hos.logs.update] ? (
        <DriverLogViewChildRoute
          exact
          path={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/:driverId/:date/addRemark`}
          onClose={onClose}
          render={(routeProps) => (
            <DriverLogAddRemark
              onClose={onClose}
              onSuccess={onSuccess}
              timeZone={record.homeTerminalTimeZone}
              {...routeProps}
              match={routeProps.match!}
            />
          )}
        />
      ) : null}
      {permissions && permissions[permissionNames.hos.logs.update] ? (
        <DriverLogViewChildRoute
          exact
          path={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/:driverId/:date/addStatus`}
          onClose={onClose}
          render={(routeProps) => (
            <DriverLogAddStatus
              onClose={onClose}
              onSuccess={onSuccess}
              timeZone={record.homeTerminalTimeZone}
              {...routeProps}
              match={routeProps.match!}
            />
          )}
        />
      ) : null}
      {permissions && permissions[permissionNames.hos.logs.addException] ? (
        <DriverLogViewChildRoute
          exact
          path={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/:driverId/:date/addException`}
          onClose={onClose}
          render={(routeProps) => (
            <DriverLogExceptionAdd
              onClose={onClose}
              onSuccess={onSuccess}
              {...routeProps}
              match={routeProps.match!}
            />
          )}
        />
      ) : null}
      {permissions && permissions[permissionNames.hos.logs.update] ? (
        <DriverLogViewChildRoute
          exact
          path={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/:driverId/:date/:eventId`}
          onClose={onClose}
          render={(routeProps) => (
            <DriverLogEventEdit
              onClose={onClose}
              id={routeProps.match?.params.eventId}
              timeZone={record.homeTerminalTimeZone}
              {...routeProps}
              match={routeProps.match!}
            />
          )}
        />
      ) : null}
    </Switch>
  );
};
